import Drawer from '@material-ui/core/Drawer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import React, { useEffect, useState } from 'react';
import { useStyles } from './styles';
import utils from '../../utils/utils';
import CloseIcon from '@material-ui/icons/Close';
import UserType from '../../constants/user';
import { STRINGS } from '../../constants';
import { Currency } from '../user_reactions/types';
import config from '../../config';
import { ReactComponent as OpenNewTab } from 'assets/svg/open-new-tab.svg';
import { PRODUCT_TYPE, TRACK_EVENT, trackEvent } from '../../utils/analytics';
import { PATH } from '../../routes/constant';
import { RootState, useAppSelector } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery, useMutation } from '@apollo/client';
import { CREATE_TRACK_SHOP_THE_ITEM } from 'graph_ql/track_shop_the_item/mutations';
import { AlgoliaInput, AlgoliaResponse } from 'graph_ql/types/types';
import { getItem_getItem_data } from '../../__generated__/getItem';
import { GET_ITEM_BY_ID } from 'graph_ql/item/queries';
import get from 'lodash/get';
import { useLocation } from 'react-router-dom';
import { pick } from 'lodash';
import { setTrackingStyle } from 'redux/analytic/analytic.slice';

const StyleImageSlider = ({ item, user, setShowDynamicItemDetail }) => {
    const location = useLocation();
    const classes = useStyles();
    const storeId = useAppSelector((state: RootState) => state.widget.store?.id);
    const taffiStoreId = useSelector((state: RootState) => state.global.taffiStoreId);
    const [createTrackShopTheItem] = useMutation(CREATE_TRACK_SHOP_THE_ITEM);
    const dispatch = useDispatch();
    const style = useSelector((state: RootState) => state.analytic.trackingStyle);
    const [itemDetail, setItemDetail] = useState<any>(null);

    const [getItemDetail] = useLazyQuery<AlgoliaResponse<getItem_getItem_data, 'algolia_get_item_by_id'>, AlgoliaInput>(
        GET_ITEM_BY_ID,
        {
            onCompleted: (data) => {
                const detail = get(data, ['algolia_get_item_by_id', 'hits', 0], null);
                setItemDetail(detail);
            },
        },
    );

    useEffect(() => {
        if (item?.taffiId) {
            getItemDetail({
                variables: {
                    filters: `taffiId:${item?.taffiId}`,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item?.taffiId]);

    const onClose = () => {
        setShowDynamicItemDetail(null);
        dispatch(setTrackingStyle(null));
    };

    const handleBottomButton = () => {
        try {
            trackEvent(TRACK_EVENT.SHOP_THE_PRODUCT, {
                product_type: PRODUCT_TYPE.ITEM,
                contextType: style ? PRODUCT_TYPE.STYLE : '',
                contextId: style?.productId ?? '',
                contextTaffiId: style?.productTaffiId ?? '',
                product: pick(itemDetail, ['id', 'taffiId', 'title', 'price', 'currency', 'url']),
                recommendationSource: location.pathname,
            });
            if (storeId || taffiStoreId) {
                createTrackShopTheItem({
                    variables: {
                        input: {
                            itemId: item.id,
                            storeId: storeId || taffiStoreId,
                        },
                    },
                });
            }
            const itemUrl = new URL(item?.storeUrl);
            if (utils.isAppInWidgetMode()) {
                itemUrl?.searchParams?.append(config.widgetConstants.WIDGET_INITIAL_CLOSED, 'true');
                if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_PATH)) {
                    itemUrl?.searchParams?.set(config.widgetConstants.TAFFI_PATH, `${PATH.STYLE_ASSISTANT}`);
                } else {
                    itemUrl?.searchParams?.append(config.widgetConstants.TAFFI_PATH, `${PATH.STYLE_ASSISTANT}`);
                }
            }
            window.open(itemUrl.href);
        } catch (e) {
            console.error(e);
        }
    };

    const getTitle = () => {
        if (item?.title) return item?.title;
        else if (itemDetail?.title) return itemDetail?.title;
        return '';
    };

    return (
        <Drawer
            open={Boolean(item)}
            anchor={'bottom'}
            onClose={onClose}
            PaperProps={{
                className: classes.itemImageSliderDrawer,
            }}
        >
            <div className={classes.itemDetailHeader}>
                <span className={classes.itemDetailTitle} style={{ width: 'calc(100% - 140px)' }}>
                    {getTitle()}
                </span>
                <div className={classes.itemDetailPriceAndClose}>
                    <span className={classes.itemDetailPrice}>
                        {utils.getPrice(item?.price as number, item?.currency)}
                    </span>
                    <CloseIcon className={classes.itemImagePopupCloseBtn} onClick={onClose} />
                </div>
            </div>
            <div
                style={{
                    flex: 1,
                    paddingBottom: 10,
                    height: 'calc(100% - 110px)',
                }}
            >
                <Swiper
                    className={'amira-item-image-slide'}
                    style={{ height: '100%' }}
                    pagination={{ clickable: true }}
                    centeredSlides={true}
                >
                    {item?.images?.map((i, idx) => (
                        <SwiperSlide
                            key={idx}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <div className={classes.itemImageSlideWrapper}>
                                <img src={i} alt={item?.title} className={classes.imageImageSlide} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {(!user || user.userType === UserType.Customer) && (
                <button className={classes.shopButton} onClick={() => handleBottomButton()}>
                    <span
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {STRINGS.SHOP_ITEM}
                        {(utils.isAppInWidgetMode() || item?.currency !== Currency.Sar || config.removeCheckOut) && (
                            <OpenNewTab style={{ marginLeft: 8 }} />
                        )}
                    </span>
                </button>
            )}
        </Drawer>
    );
};

export default StyleImageSlider;
